
angular.module('bmsApp.crm.document', [
	'ui.router'
])
	.config([
		'$stateProvider', 'BMSPermission', function config(
			$stateProvider,
			BMSPermission
			) {

			$stateProvider

				.state('main.crm.document', {
					abstract: true,
					data: {
						authorisedRoles: [BMSPermission.CRM]
					}
				})
				
				.state('main.crm.document.index', {
					url: '/documents',
					views: {
						'content@main.crm': {
							templateUrl: "ng/crm/document/templates/DocumentIndex.html",
							controller: 'DocumentIndexCtrl'
						},
						'side@main.crm': {
							templateUrl: "ng/crm/document/templates/DocumentDropzone.html",
							controller: 'DocumentDropzoneCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Documents'}
				})

				;
				
		}]);
